import { featuredBlogs } from "../../data/resourcesData";
import ResourceHero from "./ResourceHero";
import "../../css/FeaturedBlogs.css";

export default function FeaturedBlogs() {
  return (
    <>
      <ResourceHero
        title="Featured Blogs"
        subtitle="Stay updated with the latest educational insights, school news, learning tips, and inspiring stories from our community."
        image="/images/Education_Funds2.png"
      />

      <section className="resources-section" id="featured-blogs">
        <div className="resources-heading-row">
          <h2 className="resources-heading">
            Featured Blogs
          </h2>
        </div>

        <div className="resources-card-grid">
          {featuredBlogs.map((blog, index) => (
            <a
              href={blog.href}
              key={index}
              className="resources-featured-card"
            >
              <div className="featured-image-wrapper">

                <img
                  src={blog.image}
                  alt={blog.title}
                  className="featured-image"
                />

                <span className="resources-tags">
                  {blog.tags}
                </span>

              </div>


              <div className="featured-content">

                <div className="resources-meta">
                  <span>{blog.author}</span>
                  <span>{blog.date}</span>
                </div>


                <h3>
                  {blog.title}
                </h3>


                <p>
                  {blog.excerpt}
                </p>

              </div>

            </a>
          ))}
        </div>
      </section>


      <section className="editors-picks">

        <div className="container">

          <div className="section-heading">

            <span>
              Editor's Choice
            </span>


            <h2>
              Handpicked Articles For You
            </h2>


            <p>
              Explore carefully selected articles that provide valuable
              insights into education, parenting, student success and school life.
            </p>

          </div>


          <div className="pick-grid">

            <div className="pick-card">
              <h3>
                Learning Beyond Classrooms
              </h3>

              <p>
                Discover how experiential learning helps students build
                confidence and practical knowledge.
              </p>
            </div>


            <div className="pick-card">
              <h3>
                Modern Teaching Methods
              </h3>

              <p>
                Learn how technology and innovative teaching create engaging
                classroom experiences.
              </p>
            </div>


            <div className="pick-card">
              <h3>
                Parent Partnership
              </h3>

              <p>
                Strong collaboration between parents and teachers supports
                every child's growth.
              </p>
            </div>


            <div className="pick-card">
              <h3>
                Student Achievements
              </h3>

              <p>
                Celebrate inspiring stories of students achieving excellence
                in academics and beyond.
              </p>
            </div>

          </div>

        </div>

      </section>


      <section className="featured-info">

        <div className="container featured-wrapper">

          <div className="featured-text">

            <span>
              Why Featured?
            </span>


            <h2>
              Articles That Inspire Learning
            </h2>


            <p>
              Our featured blogs are selected to provide practical advice,
              educational trends and inspiring stories that benefit students,
              parents and educators alike.
            </p>


            <ul>

              <li>
                Expert Educational Insights
              </li>

              <li>
                Parenting Tips & Guidance
              </li>

              <li>
                Student Success Stories
              </li>

              <li>
                Innovation In Education
              </li>

              <li>
                School Activities & Events
              </li>

            </ul>

          </div>


          <div className="featured-side-image">

            <img
              src="/images/k.jpeg"
              alt="Featured Blog"
            />

          </div>

        </div>

      </section>

    </>
  );
}